import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SaleService } from 'src/app/service/sale.service';
import { ProductSold } from '../sale/productSold';

@Component({
  selector: 'app-sale-dialog-imprimir',
  templateUrl: './sale-dialog-imprimir.component.html',
  styleUrls: ['./sale-dialog-imprimir.component.scss']
})
export class SaleDialogImprimirComponent {

  productsSolds: ProductSold[] = [];

  ordemColunasTabela = ['quantity', 'name', 'price','desconto', 'priceTotal'];

  constructor(
    public dialogRef: MatDialogRef<SaleDialogImprimirComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private saleService: SaleService) {
      this.productsSolds = data.sale.productSolds;  
    }

  ngOnInit(): void {
  }

}
